export const StatusType = Object.freeze({
    OPEN: "open",
    ASSIGNED: "assigned",
    SCHEDULED: "scheduled",
    COMPLETED: "completed",
});
